<template>
  <div class="video-card-wrapper">
    <el-card :body-style="{ padding: '0px' }" class="video-card shadow-hover">
      <router-link :to="`/vod/video/${video.videoId}`" class="cover-link">
        <div class="image-container">
          <el-image
            lazy
            fit="cover"
            class="cover-img"
            :src="video.coverUrl"
          />

          <div class="status-top">
            <i v-if="!video.cached" class="el-icon-close icon-uncached" title="未缓存" />
            <span class="duration">{{ video.duration }}</span>
          </div>

          <div class="status-bottom">
            <div class="status-left">
              <i v-if="video.horizontal" class="el-icon-monitor" />
              <i v-else class="el-icon-mobile-phone" />
              <span class="data-item">
                <i class="el-icon-video-play" /> {{ getVisited(video.view) }}
              </span>
              <span class="data-item">
                <i class="el-icon-s-comment" /> {{ getVisited(video.comment) }}
              </span>
            </div>
          </div>
        </div>
      </router-link>

      <div class="content-section">
        <router-link :to="`/vod/video/${video.videoId}`" class="title-link">
          <h3 class="video-title">{{ video.title }}</h3>
        </router-link>

        <div class="meta-info">
          <template v-if="video.user">
            <router-link :to="`/vod/user/${video.user.userId}`" class="user-link">
              <i class="el-icon-user" /> {{ video.user.screenName }}
            </router-link>
            <span class="dot">•</span>
          </template>
          <span class="pub-date">{{ video.pubDateStr }}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { handleVisited } from 'assets/js/utils'

export default {
  name: 'VideoCard',
  props: {
    video: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  methods: {
    getVisited(visited) {
      return handleVisited(visited)
    }
  }
}
</script>

<style lang="scss" scoped>
.video-card-wrapper {
  padding: 0 7px;
  margin-bottom: 20px;
}

.video-card {
  border-radius: 8px;
  border: none;
  overflow: hidden;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
  }
}

.image-container {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9; // 锁定比例，防止布局跳动
  overflow: hidden;
  background-color: #f0f0f0;

  .cover-img {
    width: 100%;
    height: 100%;
    display: block;
  }

  // 图片上的文字阴影，保证清晰度
  .status-top, .status-bottom {
    position: absolute;
    z-index: 2;
    color: #fff;
    font-size: 12px;
    padding: 6px 8px;
    width: 100%;
    box-sizing: border-box;
    text-shadow: 0 1px 2px rgba(0,0,0,0.8);
  }

  .status-top {
    top: 0;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(to bottom, rgba(0,0,0,0.5), transparent);

    .icon-uncached { color: #ff4d4f; font-weight: bold; }
  }

  .status-bottom {
    bottom: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.5), transparent);

    .data-item {
      margin-left: 10px;
      i { margin-right: 2px; }
    }
  }
}

.content-section {
  padding: 12px;

  .title-link {
    text-decoration: none;
    color: #303133;

    .video-title {
      margin: 0 0 8px 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      // CSS 多行截断：替代 JS Filter
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 40px; // 固定高度防止抖动
      &:hover { color: #409EFF; }
    }
  }

  .meta-info {
    font-size: 12px;
    color: #909399;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;

    .user-link {
      color: #606266;
      text-decoration: none;
      max-width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      &:hover { color: #409EFF; }
    }

    .dot { margin: 0 4px; }
    .pub-date { flex-shrink: 0; }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .content-section {
    padding: 8px;
    .video-title {
      font-size: 12px;
      height: 34px;
    }
  }
  .image-container {
    .status-top, .status-bottom { font-size: 10px; }
  }
}
</style>
